app.controller("EmployeeLayoutController", [
    "$scope", "DocumentsService", "AuthService", "Socket", "usSpinnerService", "$rootScope", "$state", "ProfileChangedModal",
    function ($scope, DocumentsService, AuthService, Socket, usSpinnerService, $rootScope, $state, ProfileChangedModal) {
        $scope.unreadInbox = 0;
        $scope.review = 0;
        $scope.studentDocs = 0;
        $scope.employeeRights = [];
        $scope.employeeProfiles = [];
        $scope.profiles = [];
        $scope.counts = {};
        $scope.count = 0;
        $scope.isExternalProfileChangeDetected = false;

        var socket = new Socket("/documents");

        socket.on('counts', function (counts) {
            $scope.unreadInbox = counts.unreadInbox;
            $scope.review = counts.review;
        });

        var employeeBroadcastChannel = new BroadcastChannel('employee-profile');

        var sendProfileChangedMessage = function (profileId) {
            employeeBroadcastChannel.postMessage({ event: 'profileChanged', payload: { profileId: profileId } });
        };

        employeeBroadcastChannel.onmessage = function (message) {
            var data = message.data;
            if (data.event === 'profileChanged') {
                var isNotSameProfile = $scope.profile && $scope.profile._id !== data.payload.profileId;
                if (!$scope.isExternalProfileChangeDetected && isNotSameProfile) {
                    $scope.isExternalProfileChangeDetected = true;
                    ProfileChangedModal.show();
                }
            }
        };
        $scope.$on('$destroy', function () {
            employeeBroadcastChannel.close();
        });

        AuthService.getUserData().then(function (user) {
            AuthService.user = user;
            $scope.profile = user.profiles.filter(function (p) {
                return p._id === user.employee.profile;
            })[0];
            $scope.profiles = user.profiles.filter(function (p) {
                return p.type === "employee" && p.state === 'active' && p._id !== user.employee.profile;
            });

            $scope.employeeRights = user.employee.rights;

            if ($scope.profile.positionInfo) {
                AuthService.isRoot = $scope.profile.positionInfo.isRoot;
            }

            sendProfileChangedMessage($scope.profile._id);
        });

        $scope.hasEmployeeRight = function (right) {
            var value = false;
            $scope.employeeRights.forEach(function (r) {
                if (r === right) {
                    value = true;
                }
            });
            return value;
        };

        $scope.loadPage = function () {
            usSpinnerService.spin("root");
            DocumentsService.getCounts().then(function (res) {
                $scope.counts = res.data;
                setTimeout(function () {
                    let counts = res.data[AuthService.user.employee.profile];
                    $scope.unreadInbox = counts.unreadInbox;
                    $scope.review = counts.review;
                    $scope.studentDocs = counts.studentDocs;
                    usSpinnerService.stop("root");
                    setCounts();
                }, 1000)
            });
        };

        $rootScope.documentsCount = function () {
            $scope.loadPage();
            return true;
        };

        $scope.changeProfile = function (profile) {
            usSpinnerService.spin("root");
            sendProfileChangedMessage(profile._id);
            AuthService.chooseEmployeeProfile(profile._id).then(function () {
                AuthService.restore().then(function () {
                    $state.reload();
                });
            });
        }

        function setCounts () {
            $scope.profiles.forEach(p => {
                let obj = $scope.counts[p._id];
                let values = Object.values(obj);
                $scope.count = values.reduce((accumulator, value) => {
                    return accumulator + value;
                }, 0);
            })
        }

        $scope.loadPage();
    }
]);
